areaMembros.component('areaMembros.areaMembrosDetalheComponent', {
    templateUrl: 'areaMembros/areaMembrosDetalhe/areaMembrosDetalhe.html',
    controller: 'areaMembros.areaMembrosDetalheController',
    controllerAs: '$ctrl'
});

areaMembros.controller('areaMembros.areaMembrosDetalheController', ['$scope', 'coreLanguage', '$state', 'coreFb', 'coreToast', '$filter', function($scope, $text, $state, $fb, $toast, $filter) {
    const $ctrl = this;
    $scope.$text = $text;

    $ctrl.produto=null;

    const _getDominio=()=>{

        $ctrl.produtos = [];

        $fb.db.list(`cad_produtos`, [{where:['criacao.idUsuario', '==', $ctrl.idUsuario]}]).then(list=>{
            $ctrl.produtos = list.map(item=>{ 
                return {
                    id: item.id,
                    nome: item.data.nome,
                    capaUrl: item.data.perfilUrl || null
                }
            });

        });

    };

    const _getAreaMembros=()=>{
        $fb.db.get(`cad_areaMembros/${$state.params.idAreaMembros}`).then(doc=>{
            $ctrl.areaMembros = doc;
            $state.params.showGlobalLoading = false;
        });
    };

    $ctrl.setTab=(modo)=>{
        $ctrl.tabView = modo;
    };

    $ctrl.setViewForm=(value)=>{
        $ctrl.viewForm = value;
    };
    
    $ctrl.setViewFormBanner=(value)=>{
        $ctrl.viewFormBanner = value;
    };

    $ctrl.addProduto=(produto)=>{
        if(!$ctrl.areaMembros.data.produtos){ $ctrl.areaMembros.data.produtos = []; }

        let hasProduto = $filter('filter')($ctrl.areaMembros.data.produtos, {id: produto.id});

        if(hasProduto.length){
            $toast.success($text.alreadyAdded);
            return;
        }

        $ctrl.areaMembros.data.produtos.push({id:produto.id, capaUrl: produto.capaUrl })
        $ctrl.produto = null;
    };

    $ctrl.deleteProduto=(idx)=>{
        $ctrl.areaMembros.data.produtos.splice(idx, 1);
    };

    $ctrl.getProdName=(id)=>{
        if(!$ctrl.produtos){
            return;
        }

        let hasProduto = $filter('filter')($ctrl.produtos, {id:id});

        if(!hasProduto.length){
            return;
        }

        return hasProduto[0].nome;
    };
    
    $ctrl.updateProdutos=()=>{
        $state.params.showGlobalLoading = true;

        $fb.db.update($ctrl.areaMembros.path, {produtos: $ctrl.areaMembros.data.produtos}).then(()=>{
            $state.reload();
        });
    };

    $ctrl.uploadBanner=(event, mobile = false)=>{

        const file = event.target.files[0]
        const ext = file.name.split('.').pop();

        if (!['png', 'jpg', 'jpeg', 'webp', 'svg'].includes(ext.toLowerCase())) {
            return
        }

        $ctrl.loadingFile=true;

        $fb.storage.upload(`/areaMembros/${$ctrl.areaMembros.id}`, event.target.files[0]).then(url => {
            if(!mobile){
                $ctrl.areaMembros.data.inicio.capaUrl = url;
            }else{
                $ctrl.areaMembros.data.inicio.capaMobUrl = url;
            }

            $ctrl.loadingFile=false;
        });

    };

    $ctrl.updateBanner=()=>{
        $state.params.showGlobalLoading = true;

        $fb.db.update($ctrl.areaMembros.path, {
            'inicio.capaUrl': $ctrl.areaMembros.data.inicio.capaUrl, 
            'inicio.capaMobUrl': $ctrl.areaMembros.data.inicio.capaMobUrl, 
            'inicio.link': $ctrl.areaMembros.data.inicio.link || null
        }).then(()=>{
            $state.reload();
        });
    };

    $ctrl.$onInit = () => {
        
        $ctrl.idUsuario = $fb.auth.getIdToken().claims.idMaster || $fb.auth.getIdToken().claims.idUsuario;

        _getDominio();

        _getAreaMembros();

        $ctrl.setTab('inicio');

    };
    
}]);